import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap';
import moment from 'moment';
import { handlePriorityStatus, handleTaskStatus } from '../../utility/CommonFunctions';
import { apiUrl } from '../../ApiHelper/ApiUrl';
import { callApi } from '../../ApiHelper/ApiHelper';
import { toast } from 'react-toastify';

const MeetingDetailModal = ({ isOpen, toggle, selectedMeeting }) => {
    if (!selectedMeeting) return null;

    const [meetingDetail, setMeetingDetail] = useState({});
    const [isLoadingDetail, setIsLoadingDetail] = useState(false);

    useEffect(() => {
        if (isOpen == true) {
            GetMeetingDetail();
        }
    }, [isOpen]);

    const GetMeetingDetail = () => {
        let options = {
            method: "GET",
        };
        let API = apiUrl?.get_meeting_detail + `?meetingId=${selectedMeeting?.id}`;
        setIsLoadingDetail(true);
        callApi(API, options).then((response) => {
            setIsLoadingDetail(false);
            if (response?.status === true) {
                setMeetingDetail(response?.data);
            } else {
                toast.error(response?.message);
            }
        });
    };

    const getInitials = (name) => {
        if (!name) return '';
        return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
    };

    const renderAvatar = (user, bgColor = "#E28743", textColor = "#FFFFFF", size = "24px", fontSize = "10px") => {
        if (!user) return null;
        let initials = "";
        if (user?.name) {
            const nameParts = user.name.split(" ");
            initials = nameParts.length > 1
                ? nameParts[0].charAt(0) + nameParts[1].charAt(0)
                : nameParts[0].charAt(0);
        } else {
            initials = "U";
        }
        return (
            <div
                className="rounded-circle d-flex align-items-center justify-content-center shadow-sm flex-shrink-0"
                style={{
                    backgroundColor: bgColor,
                    color: textColor,
                    width: size,
                    height: size,
                    minWidth: size,
                    fontSize: fontSize,
                    fontWeight: "700",
                    letterSpacing: "0.5px"
                }}
                title={user?.name || "Unknown User"}
            >
                {initials.toUpperCase()}
            </div>
        );
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} scrollable centered size="lg" >
            <ModalHeader toggle={toggle} className="border-0 pb-2 pt-3 px-3 bg-white rounded-top-4" tag="div">
                <h5 className="fw-bolder mb-0 text-dark pe-4" style={{ letterSpacing: "-0.5px" }}>{meetingDetail?.title}</h5>
            </ModalHeader>
            <ModalBody className="px-3 pb-3 pt-2" style={{ backgroundColor: '#ffffff' }}>
                {isLoadingDetail ? (
                    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "300px" }}>
                        <Spinner color="primary" />
                    </div>
                ) : (
                    <div className="w-100">
                        <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
                            <span className="badge bg-primary-subtle text-primary fw-bold d-inline-flex align-items-center px-3 py-1 rounded-pill" style={{ fontSize: "12px" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="me-1" viewBox="0 0 16 16">
                                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                </svg>
                                Meeting
                            </span>
                            {meetingDetail?.date && (
                                <span className="badge bg-light text-secondary border fw-bold d-inline-flex align-items-center px-3 py-1 rounded-pill" style={{ fontSize: "12px" }}>
                                    {moment(meetingDetail?.date).format("DD MMM YYYY")}
                                </span>
                            )}
                        </div>

                        <div className="p-2 mb-3 rounded-3 border-0" style={{ backgroundColor: '#f8fafc' }}>
                            <p className="mb-0 text-secondary" style={{ fontSize: '13px' }}>{meetingDetail?.agenda || "No agenda provided."}</p>
                        </div>

                        <div className="row g-3 mb-3">
                            <div className="col-md-6">
                                <div className="p-2 border-0 rounded-3 bg-light h-100">
                                    <div className="text-muted text-uppercase mb-2 fw-bold" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Created By</div>
                                    <div className="d-flex align-items-center gap-2">
                                        {renderAvatar(meetingDetail?.meetingCreator, "#e83e8c", "#FFFFFF", "24px", "10px")}
                                        <span className="fw-bold text-dark text-truncate" style={{ fontSize: "13px" }}>{meetingDetail?.meetingCreator?.name || "Unknown"}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="p-2 border-0 rounded-3 bg-light h-100">
                                    <div className="text-muted text-uppercase mb-2 fw-bold" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Meeting Date</div>
                                    <div className="fw-bold text-dark" style={{ fontSize: "13px" }}>
                                        {meetingDetail?.date ? moment(meetingDetail?.date).format("DD MMM YYYY") : "Not Set"}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mb-3">
                            <div className="text-muted text-uppercase mb-2 fw-bold" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Joinees</div>
                            <div className="d-flex flex-wrap gap-2">
                                {meetingDetail?.joinees?.map((user) => (
                                    <div key={user?.id} className="d-flex align-items-center gap-2 bg-light px-2 py-1 rounded-pill border" style={{ transition: "all 0.2s", cursor: "default" }}>
                                        {renderAvatar(user, "#048604", "#FFFFFF", "24px", "10px")}
                                        <span className="fw-semibold text-dark text-capitalize" style={{ fontSize: "13px" }}>
                                            {user?.name}
                                        </span>
                                    </div>
                                ))}
                                {(!meetingDetail?.joinees || meetingDetail?.joinees?.length === 0) && (
                                    <span className="text-muted fst-italic" style={{ fontSize: '13px' }}>No joinees assigned.</span>
                                )}
                            </div>
                        </div>
                        <div className="mb-3">
                            <div className="text-muted text-uppercase mb-2 fw-bold" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Sites</div>
                            <div className="d-flex flex-wrap gap-2">
                                {meetingDetail?.sites?.map((site) => (
                                    <div key={site?.id} className="d-flex align-items-center gap-2 bg-light px-2 py-1 rounded-pill border" style={{ transition: "all 0.2s", cursor: "default" }}>
                                        <i className='bi bi-sun'></i>
                                        <span className="fw-semibold text-dark text-capitalize" style={{ fontSize: "13px" }}>
                                            {site?.name}
                                        </span>
                                    </div>
                                ))}
                                {(!meetingDetail?.sites || meetingDetail?.sites?.length === 0) && (
                                    <span className="text-muted fst-italic" style={{ fontSize: '13px' }}>No sites assigned.</span>
                                )}
                            </div>
                        </div>

                        {meetingDetail?.tasks?.length > 0 && (
                            <div className="mb-3">
                                <div className="text-muted text-uppercase mb-2 fw-bold" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Associated Tasks</div>
                                <div className="d-flex flex-column gap-2">
                                    {meetingDetail?.tasks?.map((task, index) => (
                                        <div key={task?.id} className="d-flex align-items-center justify-content-between p-2 rounded-3 border bg-light">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="bg-white rounded-circle d-flex align-items-center justify-content-center shadow-sm text-primary fw-bold border" style={{ width: '24px', height: '24px', fontSize: '12px' }}>
                                                    {index + 1}
                                                </div>
                                                <span className="fw-semibold text-dark fs-6" style={{ fontSize: "13px" }}>
                                                    {task?.title}
                                                </span>
                                            </div>
                                            <div className="d-flex gap-2">
                                                {handleTaskStatus && handleTaskStatus(task?.status)}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </ModalBody>
        </Modal>
    );
};

export default MeetingDetailModal;
